/*
  Fator 5 — motor da busca da Tabela Olfativa (usado pela página da tabela e pelo bloco da home).

  Resolve o jeito que o cliente realmente digita:
    - acento, maiúscula, apóstrofo e pontuação ("jadore" acha J'Adore, "olympea" acha Olympéa, "chanel nº5" acha Chanel 5);
    - palavras em qualquer ordem ("vip men 212" acha 212 VIP Men);
    - começo de palavra ("hugo bos", "paradox", "dio");
    - nome junto ou separado ("mont blanc" acha Montblanc, "flower bomb" acha Flowerbomb);
    - letras trocadas ou faltando ("blue de chanel" acha Bleu de Chanel, "savage" acha Sauvage);
    - apelidos escritos pelo marketing ("agua = acqua", "ch = carolina herrera").

  Regra de ouro: NUNCA tolerar erro em palavra com número. "Perfume 05" e "Perfume 95" têm uma letra de
  diferença; quem procura o 05 não pode receber o 95. O mesmo vale para "212 VIP Men" e "212 VIP Women".

  Busca tambem por TIPO DE CHEIRO (familia olfativa, materias-primas e notas), quando o item traz
  `.aroma`: "amadeirado", "citrico", "sandalo", "floral frutal". Ver a secao mais abaixo.

  Resultado vem em dois grupos: "diretos" (o cliente escreveu certo o bastante) e "sugestoes"
  (so apareceram porque toleramos erro). Cada acerto vindo do cheiro leva a marca `aroma: true`,
  para a tela poder dizer de onde veio e nao pular direto para o produto.
*/
(function (raiz) {
  'use strict';

  /* Palavrinhas de ligação: contam a favor, mas não são exigidas ("acqua de gio" acha Acqua Di Gio) */
  var LIGACAO = {};
  'de di du da do dos das le la les los el by pour for the e y of em no na para com eau'.split(' ').forEach(function (p) { LIGACAO[p] = 1; });

  /* Apelidos que nenhum algoritmo adivinha (tradução, sigla, jeito de falar). O marketing pode acrescentar. */
  var APELIDOS_PADRAO = [
    'agua = acqua', 'aqua = acqua', 'azul = blue', 'vermelho = red', 'verde = green', 'preto = black',
    'ch = carolina herrera', 'ysl = yves saint laurent', 'jpg = jean paul gaultier', 'dg = dolce gabbana',
    'one million = 1 million', 'um milhao = 1 million', 'mont blanc = montblanc', 'dyor = dior',
    'boa girl = good girl', 'escandalo = scandal', 'numero 5 = chanel 5', 'channel = chanel',
    /* Grafias do site oficial que a loja nova corrigiu/padronizou (24/09): quem escreve do jeito antigo ainda acha.
       "man" vira "men" só nessas frases — sozinho quebraria o "Acqua Di Gio Man". */
    'gabanna = gabbana', 'herrera man = herrera men', '212 man = 212 men'
  ];

  function normaliza(s) {
    return (s == null ? '' : String(s))
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/\bn[º°o]\.?\s*(?=\d)/g, '')
      .replace(/&/g, ' e ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  /* Prepara um item uma única vez (no carregamento), para a busca por tecla ser só comparação */
  function prepara(texto) {
    var n = normaliza(texto);
    return { n: n, sem: n.replace(/ /g, ''), tok: n ? n.split(' ') : [] };
  }

  /* Lê a lista do marketing: uma linha por apelido, no formato "como o cliente escreve = como está no catálogo" */
  function leApelidos(texto) {
    var lista = [];
    (APELIDOS_PADRAO.concat(String(texto || '').split(/[\r\n]+/))).forEach(function (linha) {
      var p = String(linha).split('=');
      if (p.length < 2) { return; }
      var de = normaliza(p[0]);
      var para = normaliza(p.slice(1).join('='));
      if (de && para && de !== para) { lista.push([de, para]); }
    });
    return lista;
  }

  function aplicaApelidos(nq, apelidos) {
    for (var i = 0; i < apelidos.length; i++) {
      var de = apelidos[i][0];
      if (nq === de) { nq = apelidos[i][1]; continue; }
      if (nq.indexOf(de) >= 0) {
        var antes = nq;
        nq = (' ' + nq + ' ').split(' ' + de + ' ').join(' ' + apelidos[i][1] + ' ').trim();
        if (nq !== antes) { nq = nq.replace(/\s+/g, ' '); }
      }
    }
    return nq;
  }

  /* Quantas letras erradas dá para perdoar, conforme o tamanho da palavra */
  function limitePara(tamanho) {
    if (tamanho < 5) { return 0; }
    if (tamanho < 8) { return 1; }
    if (tamanho < 11) { return 2; }
    return 3;
  }

  /* Distância de Damerau-Levenshtein (conta letras trocadas de lugar como 1 erro: bleu/blue) */
  function distancia(a, b, limite) {
    var la = a.length;
    var lb = b.length;
    if (Math.abs(la - lb) > limite) { return limite + 1; }
    if (a === b) { return 0; }
    var prev2 = [];
    var prev = [];
    var cur = [];
    var j;
    for (j = 0; j <= lb; j++) { prev[j] = j; }
    for (var i = 1; i <= la; i++) {
      cur = [i];
      var melhor = i;
      for (j = 1; j <= lb; j++) {
        var custo = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + custo);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          v = Math.min(v, prev2[j - 2] + 1);
        }
        cur[j] = v;
        if (v < melhor) { melhor = v; }
      }
      if (melhor > limite) { return limite + 1; }
      prev2 = prev;
      prev = cur;
    }
    return prev[lb];
  }

  var TEM_DIGITO = /\d/;

  function mesmasLetras(a, b) {
    return a.split('').sort().join('') === b.split('').sort().join('');
  }

  /* Como esta palavra digitada casa com as palavras do item: 0 = igual, 1 = começo, 2 = com erro */
  function casaPalavra(palavra, tokens) {
    var melhor = null;
    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (t === palavra) { return { tipo: 0, edicoes: 0 }; }
      if (palavra.length >= 3 && t.indexOf(palavra) === 0) { melhor = melhor || { tipo: 1, edicoes: 0 }; }
    }
    if (melhor) { return melhor; }
    /* palavra com número não aceita erro: "Perfume 05" nunca pode virar "Perfume 95" */
    if (TEM_DIGITO.test(palavra)) { return null; }
    for (var k = 0; k < tokens.length; k++) {
      var tk = tokens[k];
      if (TEM_DIGITO.test(tk)) { continue; }
      var lim = limitePara(Math.max(palavra.length, tk.length));
      /* Palavra curta (até 4 letras) só aceita letras trocadas de lugar — "bleu/blue" sim, "polo/solo" não */
      if (!lim) {
        if (palavra.length === tk.length && mesmasLetras(palavra, tk) && distancia(palavra, tk, 1) === 1) {
          if (!melhor || melhor.edicoes > 1) { melhor = { tipo: 2, edicoes: 1 }; }
        }
        continue;
      }
      var d = distancia(palavra, tk, lim);
      if (d <= lim && (!melhor || d < melhor.edicoes)) { melhor = { tipo: 2, edicoes: d }; }
    }
    return melhor;
  }

  /* ---------- Tipo de cheiro: familia olfativa, materias-primas e notas ----------
     O catalogo escreve "Madeira Suave", "Frutas Citricas", "Notas Doces", "Sandalo".
     O cliente escreve "amadeirado", "citrico", "doce", "sandalo". Duas pontes:
       1. radical(): tira plural e genero, entao "citrico" acha "Citricas" e "rosa" acha "Rosas";
       2. SINONIMOS: o que nenhuma regra adivinha ("amadeirado" = madeira, "baunilha" = vanila).
     Quem manda e o nome: acerto exato de nome ganha sozinho, e esta camada nem roda.
     Assim "Perfume 05" continua trazendo o 05, e nunca uma lista de amadeirados. */
  var SINONIMOS = {
    amadeirado: 'madeira', amadeirada: 'madeira', amadeirados: 'madeira', madeirado: 'madeira',
    adocicado: 'doces', docinho: 'doces',
    frutado: 'frutas', frutal: 'frutas',
    apimentado: 'pimentas', picante: 'pimentas',
    citrus: 'citricas',
    baunilha: 'vanila', vanila: 'baunilha',
    patchuli: 'patchouli', patchouli: 'patchuli',
    almiscar: 'musk', musk: 'almiscar',
    tabaco: 'tabacaria',
    incenso: 'insensos', incensos: 'insensos',
    amendoa: 'amendoas'
  };

  /* Tira plural e terminacao de genero: citricas/citrico -> citric, rosas/rosa -> ros */
  function radical(p) {
    if (p.length < 4) { return p; }
    var r = p.replace(/(es|s)$/, '');
    if (r.length > 3) { r = r.replace(/[oae]$/, ''); }
    return r;
  }

  /* Como a palavra digitada casa com o tipo de cheiro do produto: 0 = certo, 1 = com erro, null = nao casa */
  function casaAroma(palavra, tokens) {
    var tentativas = SINONIMOS[palavra] ? [palavra, SINONIMOS[palavra]] : [palavra];
    var t, i, alvo;
    /* 1a volta: tudo que e acerto de verdade. O sinonimo precisa ser testado ANTES de perdoar erro,
       senao "incenso" casa por semelhanca com "insensos" e vira "com erro" em vez de acerto. */
    for (t = 0; t < tentativas.length; t++) {
      alvo = tentativas[t];
      var rad = radical(alvo);
      for (i = 0; i < tokens.length; i++) {
        var tk = tokens[i];
        if (tk === alvo) { return 0; }
        if (alvo.length >= 4 && tk.indexOf(alvo) === 0) { return 0; }
        /* radical curto junta palavra sem parentesco (amor/amora, mais/maio, coca/coco) */
        if (rad.length >= 5 && radical(tk) === rad) { return 0; }
      }
    }
    /* 2a volta: perdoa erro de digitacao, com regua mais apertada que a do nome.
       Sao centenas de palavras de notas; com a regua larga "marca" viraria maca e "romantico" viraria aromatico. */
    for (t = 0; t < tentativas.length; t++) {
      alvo = tentativas[t];
      if (alvo.length < 6) { continue; }
      var c = casaPalavra(alvo, tokens);
      if (c && c.tipo === 2 && c.edicoes <= 1) { return 1; }
      if (c && c.tipo !== 2) { return 0; }
    }
    return null;
  }

  /*
    Busca. `itens` é uma lista de objetos com `.busca` e, opcionalmente, `.aroma` (ambos vindos de prepara()).
    Devolve { diretos: [...], sugestoes: [...] }, cada um com { item, edicoes }.
  */
  function busca(itens, consulta, apelidos) {
    var nq = aplicaApelidos(normaliza(consulta), apelidos || []);
    var vazio = { diretos: [], sugestoes: [], termo: nq };
    if (!nq) { return vazio; }
    var qsem = nq.replace(/ /g, '');
    var todas = nq.split(' ');
    var palavras = todas.filter(function (p) { return !LIGACAO[p]; });
    if (!palavras.length) { palavras = todas; }

    var diretos = [];
    var sugestoes = [];
    for (var i = 0; i < itens.length; i++) {
      var it = itens[i];
      var b = it.busca;
      if (!b || !b.n) { continue; }

      if (b.n.indexOf(nq) === 0) { diretos.push({ item: it, peso: 0, edicoes: 0, ordem: i }); continue; }
      if (b.n.indexOf(nq) >= 0 || (qsem.length >= 4 && b.sem.indexOf(qsem) >= 0)) {
        diretos.push({ item: it, peso: 1, edicoes: 0, ordem: i });
        continue;
      }

      var edicoes = 0;
      var comErro = false;
      var casouTudo = true;
      for (var p = 0; p < palavras.length; p++) {
        var c = casaPalavra(palavras[p], b.tok);
        if (!c) { casouTudo = false; break; }
        if (c.tipo === 2) { comErro = true; edicoes += c.edicoes; }
      }
      if (!casouTudo) { continue; }
      if (comErro) { sugestoes.push({ item: it, peso: 3, edicoes: edicoes, ordem: i }); }
      else { diretos.push({ item: it, peso: 2, edicoes: 0, ordem: i }); }
    }

    /* Nada pelo nome? Entao procura pelo tipo de cheiro (familia, materias-primas e notas).
       Quem digita "bulgari" quer Bvlgari, nao os perfumes com nota "Rosa da Bulgaria"; mas quem
       digita "doce" quer perfume doce, e nao so os Dolce & Gabbana. Entao: acerto exato de nome
       ganha sozinho; nome escrito errado vem PRIMEIRO e o cheiro entra logo abaixo, na mesma lista.
       Assim o cliente ve a marca que procurou sem perder os perfumes daquele cheiro. */
    if (!diretos.length) {
      var destino = sugestoes.length ? sugestoes : diretos;
      var piso = sugestoes.length ? 3.2 : 2.2;
      /* Quem o nome ja achou nao entra de novo: "doce" acha Dolce & Gabbana Woman pelo nome E pelo
         cheiro ("Notas Doces"), e sem isso o mesmo produto seria contado duas vezes. */
      var jaTem = {};
      for (var d = 0; d < diretos.length; d++) { jaTem[diretos[d].ordem] = 1; }
      for (var g = 0; g < sugestoes.length; g++) { jaTem[sugestoes[g].ordem] = 1; }
      for (var a = 0; a < itens.length; a++) {
        if (jaTem[a]) { continue; }
        var ia = itens[a];
        var ar = ia.aroma;
        if (!ar || !ar.n) { continue; }
        var erros = 0;
        var casouAroma = true;
        for (var w = 0; w < palavras.length; w++) {
          var ca = casaAroma(palavras[w], ar.tok);
          if (ca === null) { casouAroma = false; break; }
          erros += ca;
        }
        if (!casouAroma) { continue; }
        /* "madeira aromatica" escrito inteiro vem antes de quem só tem as duas palavras soltas */
        var frase = ar.n.indexOf(nq) >= 0;
        /* Tudo vai para a mesma lista: o catalogo escreve "jasmin" e "jasmim", "vanila" e "baunilha".
           Se o acerto com 1 letra de erro fosse para outra lista, sumiria da tela e o cliente veria
           4 de 11 jasmins. O peso so empurra esses para o fim. */
        destino.push({ item: ia, peso: piso + (frase ? 0 : (erros ? 0.6 : 0.3)), edicoes: erros, ordem: a, aroma: true });
      }
    }

    var ordena = function (a, b2) { return a.peso - b2.peso || a.edicoes - b2.edicoes || a.ordem - b2.ordem; };
    diretos.sort(ordena);
    sugestoes.sort(ordena);
    return { diretos: diretos, sugestoes: sugestoes, termo: nq };
  }

  raiz.BuscaOlfativa = {
    normaliza: normaliza,
    prepara: prepara,
    leApelidos: leApelidos,
    busca: busca,
    distancia: distancia,
    radical: radical,
    casaAroma: casaAroma,
    limitePara: limitePara
  };
}(typeof window !== 'undefined' ? window : globalThis));
